import {Directive, Input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {UserService} from "../services";

/**
 * Отображение шаблона в зависимости от проверяемого свойства isAuthenticated директивы.
 * condition - true / false. Блоки будут отображаться смотря что мы хотим видеть при потери авторизации или ее наличия
 */
@Directive({selector: '[appShowAuth]'})
export class ShowAuthDirective implements OnInit {
  constructor(private templateRef: TemplateRef<any>,
              private userService: UserService,
              private viewContainer: ViewContainerRef) {
  }

  condition: boolean;

  ngOnInit() {
    this.userService.isAuthenticated.subscribe(
      (isAuthenticated) => {
        this.viewContainer.clear();
        if (isAuthenticated && this.condition || !isAuthenticated && !this.condition) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      }
    );
  }

  @Input() set appShowAuth(condition: boolean) {
    this.condition = condition;
  }

}
